import { ConnectedStatusFooter } from 'components/shared/ScheduledRun/Blotter/panel/Shared/StatusFooter';

export const OverviewFooter = ConnectedStatusFooter;
